import { MutationTree } from 'vuex';
import { RestrictionsState } from './types';

export const mutations: MutationTree<RestrictionsState> = {
  setRestrictions: (state, data) => {
    state.restrictions = data
  },
  setRestriction: (state, data) => {
    state.restriction = data
  },
}